import { Skeleton } from '@elmnts/ui/skeleton'

/**
 * Esqueleto com a FORMA da home (cabeçalho + grade de cards), não um spinner
 * centralizado: o spinner antigo ficava no meio da tela e o conteúdo aparecia
 * de repente em outro lugar, produzindo um salto a cada carga.
 */
export function ChannelHomeSkeleton() {
  return (
    <div role="status" aria-label="Carregando canais" className="flex flex-col gap-8">
      <div className="flex flex-col gap-6">
        <Skeleton className="size-10 rounded-xl" />
        <div className="flex flex-col gap-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-40" />
        </div>
      </div>

      <div className="grid grid-cols-[repeat(auto-fill,minmax(17rem,1fr))] gap-4">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-40 rounded-xl" />
        ))}
      </div>
    </div>
  )
}
